import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";

import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";

import Widget from "components/widget/Widget";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";
import { useEffect, useState } from "react";
import axios from "axios";
import { ApiUrl } from "Services/Services";
import { formatToPakistaniCurrency } from "Services/Services";

const Dashboard = () => {
const [count , setCount]= useState([]);
  useEffect(()=>{
    const fetchDashboardCount = async()=>{
      try {
        const response  = await axios.get(`${ApiUrl}/auth/dashboard/count`);
        setCount(response.data);
      } catch (error) {
        console.log(error)
      }
    }
    fetchDashboardCount();
  },[])
  return (
    <div>
      {/* Card widget */}

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Users"}
          subtitle={count?.Users}
        />
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={"New Orders"}
          subtitle={count?.Orders}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Branches"}
          subtitle={count.categories}
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"Foods"}
          subtitle={count?.FoodCount}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Today Revenue"}
          subtitle={formatToPakistaniCurrency(count?.todayEarning)}
        />
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"Cancelled Orders"}
          subtitle={count?.CancelledOrders}
        />
      </div>

      {/* Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div>

      {/* Tables & Charts */}

      {/* <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
       
        <div>
          <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          />
        </div>

       

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <PieChartCard />
        </div>

       

        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />

       

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
